export default class SerialPort {
  constructor() {}
  pipe() {}
  write() {}
  drain() {}
  open() {}
  close() {}
}



// WEBPACK FOOTER //
// ./src/mainInterface/js/serialPortNode.js